const works = (Vue, request) => {
	//列表
	Vue.prototype.getWorksListApi = (data) => {
		return request({
			url: '/web-api/works',
			params:{
				limit:1000,
				flag: 1,
			},
			method: 'get',
		})
	}
	//详情
	Vue.prototype.getWorksInfoApi = (id) => {
		return request({
			url: `/web-api/works/${id}`,
			method: 'get',
		})
	}
	//图片配置
	Vue.prototype.getImagesUrl = () => {
		return request({
			url: '/web-api/config/system',
			method: 'get',
		})
	}
}
export default works
